export default __webpack_public_path__ + "static/media/music-icon.9e223fd4.png";